import { render, staticRenderFns } from "./bo-dropdown-menu.vue?vue&type=template&id=7151a40c"
import script from "./bo-dropdown-menu.vue?vue&type=script&lang=js"
export * from "./bo-dropdown-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports